import { EditProgramDialogComponent } from "./edit-program-dialog";
import { NewProgramDialogComponent } from "./new-program-dialog";

export const dialogs = [EditProgramDialogComponent, NewProgramDialogComponent];

export { EditProgramDialogComponent, NewProgramDialogComponent };
